import { useContext, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import RegularHeader from "components/TableDetails/components/RegularHeader";
import TableContext from "context/table/tableContext";
import {
    API_IS_BEING_CANCELLED,
    ENDPOINTS,
    RectangleLoader,
    useApi,
    useFormattedNumber,
    useIsMounted
} from "shared";

const Header = () => {
    const { detailsData } = useContext(TableContext);

    const { t } = useTranslation();
    const { cancelSource, getData, handleResponse, isCanceled } = useApi();
    const { renderFormattedNumber } = useFormattedNumber();
    const isMounted = useIsMounted();

    const { id, name, company } = detailsData;

    const [isLoading, setIsLoading] = useState(true);
    const [devicesCount, setDevicesCount] = useState(0);

    useEffect(() => {
        const getDeviceCount = async () => {
            try {
                setIsLoading(true);

                const { data } = await getData(`${ENDPOINTS.Groups}/${id}`);

                if (isMounted) {
                    setDevicesCount(data.device_count);
                }
            } catch (error) {
                if (isMounted && !isCanceled(error)) {
                    handleResponse(error);
                }
            }

            setIsLoading(false);
        };

        getDeviceCount();

        return () => {
            cancelSource.cancel(API_IS_BEING_CANCELLED);
        };

        // eslint-disable-next-line
    }, [id]);

    return (
        <RegularHeader
            titleValue={name}
            subtitleName={t(`Table##company`)}
            subtitleValue={company.name}
            additionalSubtitleName={t("Table details##number of devices")}
            additionalSubtitleValue={
                isLoading ? (
                    <RectangleLoader height={20} width={60} />
                ) : (
                    renderFormattedNumber(devicesCount)
                )
            }
        />
    );
};

export default Header;
